import React, { useState } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Modal,
  Checkbox,
  Switch,
  Spin,
  message,
} from "antd";
import API_MANAGER from "../../../API";
// import API_MANAGER from "../../../API";
// import axios from "axios";
// import { s3PreUrl } from "../../../constants";

function AddExperience({
  addExperience,
  setAddExperience,
  jobTitle,
  industry,
  discipline,
  induction,
  skills,
  userId,
}) {
  const [experienceForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(false);
  const [showReferee, setShowReferee] = useState(false);
  const onFinish = async (values) => {
    // This function only runs if validation passes
    // If validation fails, onFinishFailed will be called instead
    try {
      setLoading(true);
      values.userId = userId;
      values.jobDetails = values.skills;
      values.currentRole = currentStatus;
      await API_MANAGER.createCandidateExperience(values);
      message.success("Successfully added experience");
      setAddExperience(false);
    } catch (error) {
      // This is a backend error
      message.error(error.response?.data?.message?.message || 'An error occurred');
    }
    setLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form validation failed:', errorInfo);
    console.log('Error fields:', errorInfo.errorFields);
    // The validation messages will automatically appear below the fields
    // No API call will be made
    message.error('Please fill in all mandatory fields');
  };
  return (
    <>
      <Modal
        centered
        footer={false}
        open={addExperience}
        title={"Experience Add"}
        className="resumeModal"
        onCancel={() => setAddExperience(false)}
      >
        <Form 
          form={experienceForm} 
          layout="vertical" 
          requiredMark={false}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          validateTrigger="onSubmit"
        >
          <Spin spinning={loading} />
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item 
                label="Employer*" 
                name="employerName"
                rules={[
                  {
                    required: true,
                    message: 'Please enter employer name'
                  }
                ]}
              >
                <Input placeholder="Employer" />
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item label="Project Name" name="projectName">
                <Input placeholder="Project Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item 
                label="Job Title*" 
                name="jobTitle"
                rules={[
                  {
                    required: true,
                    message: 'Please select job title'
                  }
                ]}
              >
                <Select 
                  className="" 
                  placeholder="industry"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {jobTitle?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e.id}>
                        {e.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item 
                label="Industry*" 
                name="industry"
                rules={[
                  {
                    required: true,
                    message: 'Please select industry'
                  }
                ]}
              >
                <Select 
                  className="" 
                  placeholder="industry"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {industry?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e.id}>
                        {e.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item 
                label="Discipline*" 
                name="discipline"
                rules={[
                  {
                    required: true,
                    message: 'Please select discipline'
                  }
                ]}
              >
                <Select 
                  className="" 
                  placeholder="discipline"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {discipline?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e.id}>
                        {e.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item 
                label="Inductions*" 
                name="inductions"
                rules={[
                  {
                    required: true,
                    message: 'Please select inductions'
                  }
                ]}
              >
                <Select
                  className=""
                  mode="multiple"
                  maxTagCount="responsive"
                  placeholder="inductions"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {induction?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e.id}>
                        {e.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item
                label="Job Description, Responsibilties, Skills*"
                name="skills"
                rules={[
                  {
                    required: true,
                    message: 'Please select skills'
                  }
                ]}
              >
                <Select
                  className=""
                  mode="multiple"
                  maxTagCount="responsive"
                  placeholder="skills"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {skills?.map((e, key) => {
                    return (
                      <Select.Option key={key} value={e.id}>
                        {e.name}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item 
                label="Start Date*" 
                name="startDate"
                rules={[
                  {
                    required: true,
                    message: 'Please select start date'
                  }
                ]}
              >
                <DatePicker
                  className="w-100"
                  format={"DD-MM-YYYY"}
                  placeholder="Select start date"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item 
                label={currentStatus ? "End Date" : "End Date*"} 
                name="endDate"
                rules={[
                  {
                    required: !currentStatus,
                    message: 'Please select end date'
                  }
                ]}
              >
                <DatePicker
                  className="w-100"
                  format={"DD-MM-YYYY"}
                  placeholder="Select end date"
                  disabled={currentStatus}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={12}>
              <Form.Item name="hasReferee">
                <Checkbox
                  defaultChecked={showReferee}
                  onChange={() => setShowReferee(!showReferee)}
                >
                  Referee Details
                </Checkbox>
              </Form.Item>
            </Col>
            <Col xs={12}>
              <Form.Item name="currentRole">
                <span style={{ marginRight: "10px" }}>Current Role</span>
                <Switch
                  checked={currentStatus}
                  onClick={(e) => {
                    setCurrentStatus(e);
                    if (e) {
                      experienceForm.setFieldsValue({ endDate: null });
                    }
                    setTimeout(() => {
                      experienceForm.validateFields(['endDate']);
                    }, 0);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          {showReferee ? (
            <>
              <Row gutter={24}>
                <Col xs={12}>
                  <Form.Item 
                    label="Referee Name*" 
                    name="refereeName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee name",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={12}>
                  <Form.Item 
                    label="Referee Position*" 
                    name="refereePosition"
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee position",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={12}>
                  <Form.Item
                    label="Referee Email/ Phone Number*"
                    name="refereeContact"
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee email or phone number",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>{" "}
            </>
          ) : (
            ""
          )}

          <Row>
            <Col xs={24} className="buttonCol">
              <Button className="btn1" htmlType="submit">
                Create
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
export default AddExperience;
